import { withInstall } from '@map-sdk/utils'

import baseDrawshipcount from './src/index.vue'

export const BaseDrawshipcount = withInstall(baseDrawshipcount)
export default BaseDrawshipcount
